import { COLORS } from "@coeff/utils";
import { Button as ButtonAD, Popover as PopoverAD, PopoverProps as PopoverPropsAD } from "antd";
import clsx from "clsx";
import React, { ReactElement, useContext, useRef } from "react";
import styled from "styled-components";

import { DEPRECATED_Button } from "../../common/DEPRECATED_Button";
import { PPressContextParams, PpressContext, PPressComponentProps } from "../context";

import { Button } from "./Button";

const DropdownWrap = styled.div`
  width: 250px;

  .coeff__card {
    margin: 0px;
    background: ${COLORS.white};

    > div {
      padding: 0px;
    }
  }

  .coeff__card_header,
  .coeff__sorts_title {
    display: none;
  }

  .coeff__filter-item,
  .coeff__sort-item {
    background: ${COLORS.coeblue};
  }
`;

const MenuButton = styled(ButtonAD)`
  font-weight: 600;
`;

type PopoverProps = {
  dropdownContent: ReactElement;
  label?: string;
  labelIcon?: React.ReactNode;
  active?: boolean;
  onClose?: () => void;
  ButtonProps?: Record<string, string | Record<string, string>>;
  clearButton?: React.ReactNode;
} & PopoverPropsAD &
  PPressComponentProps;

export const Popover: React.FC<PopoverProps> = ({
  dropdownContent,
  label,
  labelIcon,
  onClose,
  active = false,
  ButtonProps,
  clearButton,
  ...props
}) => {
  const form_state = useContext(PpressContext) as PPressContextParams;

  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleDropdownClose = () => {
    // force click the button to close the dropdown
    if (buttonRef && buttonRef.current) {
      buttonRef.current.click();
    }

    if (onClose) {
      onClose();
    } else {
      if (props.updateFromServerOnChange) {
        return form_state.updateFormFromServer(form_state.ppress_params);
      } else {
        return form_state.updatePPressParams(form_state.ppress_params);
      }
    }
  };

  return (
    <PopoverAD
      content={
        <DropdownWrap>
          {dropdownContent}

          <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between" }}>
            {clearButton ?? <div />}

            <DEPRECATED_Button
              type="primary"
              onClick={handleDropdownClose}
              data-test-id="ppress-toolbar-sort-done"
            >
              Done
            </DEPRECATED_Button>
          </div>
        </DropdownWrap>
      }
      placement="bottomLeft"
      overlayClassName="no-arrow"
      trigger="click"
      {...props}
    >
      <MenuButton
        ref={buttonRef}
        className={clsx("toolbar-btn", { active })}
        icon={labelIcon}
        {...ButtonProps}
      >
        {label ?? "Open"}
      </MenuButton>
    </PopoverAD>
  );
};
